import { render, staticRenderFns } from "./ConfigurationUpsellCart.vue?vue&type=template&id=97013ac4&"
import script from "./ConfigurationUpsellCart.vue?vue&type=script&lang=js&"
export * from "./ConfigurationUpsellCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports